import * as playerConstants from "../../utils/playerConstants";
import PlayerUtil from './../../devices/all/PlayerUtil';
import CertificateTask from "../../requests/tasks/video/CertificateTask";
import RequestManager from "../../requests/RequestManager";

class STBSEIRoboticsPlayerUtil extends PlayerUtil {

    constructor() {
        super();
    }

    async getCertificate(url){
        const certificateTask = new CertificateTask(url);
        let certificateResult = await RequestManager.addRequest(certificateTask);
        let cert = new Uint8Array(certificateResult);
        return cert;
    }

    async replaceSourceMedia(pgm, streamType, provider = null, providerCode = null, isLive = false) {
        switch (streamType) {
            case playerConstants.DASHWV:
            case playerConstants.DASHWV_MA:
             if(pgm.media && pgm.media.certificate_url && providerCode !== 'hbo'){
                pgm.media.resultCert = await this.getCertificate(pgm.media.certificate_url); 
             }
              break;
            default:
              return pgm;
        }

        return pgm;
    }
}

export default STBSEIRoboticsPlayerUtil;



// WEBPACK FOOTER //
// ./src/devices/seirobotics/PlayerUtil.js